<template>
  <v-card-text>
    <ConfirmationDialog2 ref="confirmationDialog" />
    <div class="title font-weight-regular">Documents
      <v-menu v-model="addMenu" :close-on-content-click="false" :close-on-click="false" offset-x :nudge-width="200">
        <template v-slot:activator="{ on }">
          <SecondaryBtn small icon="add" color="success" v-on="on">
            {{ $t('Button.AddDocumentReference') }}
          </SecondaryBtn>
        </template>
        <v-card>
          <v-card-text>
            Please enter the correct url of the document.
            <v-text-field label="Document URL" single-line v-model="inputUrl"></v-text-field>
            <v-text-field label="Note" single-line v-model="inputNote"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <PrimaryBtn small icon="add" color="success" :disabled="!inputUrl" @click="addDocument()">
              {{ $t('Button.Add') }}
            </PrimaryBtn>
            <SecondaryBtn small @click="closeAndClear()">{{ $t('Button.Cancel') }}</SecondaryBtn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </div>
    <span v-for="(document,index) in documents" :key="index" class="mr-1">
      <v-btn depressed small :href="`/uploads/${document.FileName}`" download class="mx-0">
        <v-icon class="mr-1">save_alt</v-icon>
        {{getFileName(document.FileName)}}
      </v-btn>
      <span v-if="document.Notes && document.Notes.length > 0" class="mx-0 span-color">Note: {{document.Notes}}</span>
      <v-btn icon class="mx-0" @click="removeDocument(document)">
        <v-icon color="error">link_off</v-icon>
      </v-btn>
    </span>

    <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
      {{ snackMessage }}
      <v-btn dark flat @click.native.stop.prevent="snackbar = false">{{ $t('Button.Close') }}</v-btn>
    </v-snackbar>

    <ErrorDialog v-model="errorDialog.show" :data="errorDialog.data" :title="errorDialog.title"></ErrorDialog>
  </v-card-text>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import SnackBarUtil from '@/components/mixins/SnackBarUtil'
  import ErrorDialog from '@/components/generic/ErrorDialog'
  const imports = createNamespacedHelpers('imports')
  const sampleactivity = createNamespacedHelpers('sampleactivity')
  const regex = /\\|\//g

  export default {
    components: {
      ErrorDialog,
    },
    mixins: [SnackBarUtil],
    props: {
      documents: {
        type: Array,
        default: [],
      },
    },
    data() {
      return {
        addMenu: false,
        inputUrl: '',
        inputNote: '',
      }
    },
    computed: {
      ...imports.mapGetters(['currentImport']),
      errorDialog() {
        return this.$store.getters['app/errorDialog']
      },
    },
    watch: {},
    methods: {
      ...sampleactivity.mapActions(['addSampleDocument', 'deleteSampleDocument']),
      getFileName(fullName) {
        if (fullName != null) {
          let name = fullName.split(regex).pop()
          return name
        }
        return ''
      },
      closeAndClear() {
        this.addMenu = false
        this.inputUrl = ''
        this.inputNote = ''
      },
      addDocument() {
        let options = {
          data: {
            Id: null,
            FileName: this.inputUrl,
            Notes: this.inputNote,
            IsPrimary: true,
            ImportId: this.currentImport.Id,
          },
          successCb: () => {
            this.closeAndClear()
            this.handleNotification({
              type: 'success',
              message: 'Document added successfully',
            })
          },
          failedCb: (err) => {
            this.$store.dispatch('app/setErrorDialog', {
              data: err.response.data,
              title: err.message,
              show: true,
            })
          },
        }
        this.addSampleDocument(options)
      },
      async removeDocument(document) {
        let confirmed = await this.$refs.confirmationDialog.confirm({
          text: 'Are you sure you want to delete this document reference? The document will still exist on our server, but will not no longer be linked to this import.',
          title: 'Delete document reference',
          confirmText: 'Delete',
          cancelText: 'Cancel',
          color: 'error',
          icon: 'link_off',
        })
        if (!confirmed) return
        let options = {
          sampleDocumentId: document.Id,
          successCb: () => {
            this.handleNotification({
              type: 'success',
              message: 'Document deleted successfully',
            })
          },
          failedCb: (err) => {
            this.$store.dispatch('app/setErrorDialog', {
              data: err.response.data,
              title: err.message,
              show: true,
            })
          },
        }
        this.deleteSampleDocument(options)
      },
    },
  }
</script>

<style scoped>
  .btn_fab_small {
    height: 28px !important;
    width: 28px !important;
  }

  .span-color {
    color: rgba(0, 0, 0, .5)
  }
</style>